import React, { FC } from 'react';
import { ReferenceInputProps } from 'ra-ui-materialui';
import { ReferenceInput as RaReferenceInput } from 'react-admin';

const ReferenceInput: FC<ReferenceInputProps> = (props) => {
  return <RaReferenceInput perPage={9999} {...props} />;
};

export default ReferenceInput;
